<div class="modal">
  <div class="spinner-grow" role="status">
      <span class="sr-only">Loading...</span>
  </div>
</div>
<!-- <app-spinner></app-spinner> -->
<!-- <app-error></app-error> -->
<app-warn></app-warn>
<app-info></app-info>
<app-toast></app-toast>
<!-- <app-entity-help></app-entity-help> -->
<app-progress></app-progress>
<router-outlet></router-outlet>